// Legacy export for backward compatibility
// For new code, use the comprehensive utilities from './taskDateUtils'
export const createConsistentDate = (date: Date): string => {
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0),
  ).toISOString();
};
